import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import eadReadAction from './eadReadStudent.action.json'

const eadReadStudentDefinition = defineReadAutoAction(eadReadAction, 'aluno')

export default eadReadStudentDefinition
